import {
  getAnalytics,
  initializeAnalytics,
  logEvent,
} from 'firebase/analytics';
import { type FirebaseApp, getApps, initializeApp } from 'firebase/app';
import type { AnalyticsMeta } from '../types';

export type FirebaseConfigType = {
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
  measurementId: string;
};

const appsById = new Map<string, FirebaseApp>();

const getProviderKey = (providerId?: string): string => providerId ?? 'default';

const sendAnalyticsEvent = (
  eventName: string,
  meta?: AnalyticsMeta,
  providerId?: string,
): void => {
  const key = getProviderKey(providerId);
  const targetApp = appsById.get(key);
  if (targetApp) {
    logEvent(getAnalytics(targetApp), eventName, meta);
  }
};

const initFirebase = ({
  config,
  providerId,
}: {
  config: FirebaseConfigType;
  providerId?: string;
}): void => {
  const key = getProviderKey(providerId);
  const existingApp =
    appsById.get(key) ?? getApps().find((app) => app.name === key);
  if (existingApp) {
    appsById.set(key, existingApp);
    return;
  }

  const app = initializeApp(config, key);
  initializeAnalytics(app, {
    config: { cookie_flags: 'max-age=7200;secure;samesite=none' },
  });
  appsById.set(key, app);
};

export { initFirebase, sendAnalyticsEvent };
